import React, { useState } from 'react'
import RoleManagement from '../components/RoleManagement/RoleManagement'

const PageRoleManagement = () => {
  return <RoleManagement></RoleManagement>
}

export default PageRoleManagement
